import React from 'react';
import {
  Datagrid,
  DeleteButton,
  EditButton,
  FunctionField,
  List,
  SelectField,
  TextField,
  useListContext,
} from 'react-admin';
import { Alert, Chip } from '@mui/material';
import Permission from '../../components/Permission';
import RequiredChain from '../../components/RequiredChain';
import { PERMISSIONS } from '../../constants';
import {
  WhatsappScope,
  WhatsappActorType,
  SummaryFrequency,
  WhatsappIdentityStatus,
  formatPhoneBr,
} from '../../models/whatsappNumber';

/** Mostra quantos assentos a rede já usou do teto contratado. */
const QuotaBanner = () => {
  const { data } = useListContext();
  const first: any = data?.[0];
  if (!first?.maxNumbers) return null;

  const used = first.activeNumbers ?? 0;
  const max = first.maxNumbers;
  const full = used >= max;

  return (
    <Alert severity={full ? 'warning' : 'info'} sx={{ mb: 2 }}>
      {full
        ? `Você já usou os ${max} números do seu plano. Para cadastrar mais, fale com o seu contato na PontuaX.`
        : `${used} de ${max} números em uso.`}
    </Alert>
  );
};

const ListWhatsappNumber = (props) => (
  <Permission permission={PERMISSIONS.MANAGE_WHATSAPP_NUMBERS}>
    <RequiredChain>
      <List
        {...props}
        title="Números de WhatsApp"
        exporter={false}
        sort={{ field: 'createdAt', order: 'DESC' }}
      >
        <>
          <QuotaBanner />
          <Datagrid bulkActionButtons={false}>
            <FunctionField
              label="Número"
              render={(record: any) => formatPhoneBr(record?.phone)}
            />
            <TextField source="displayName" label="Quem é" />
            <SelectField
              source="actorType"
              label="Papel"
              choices={WhatsappActorType.actorChoices}
            />
            <FunctionField
              label="Enxerga"
              render={(record: any) =>
                record?.scope === WhatsappScope.places
                  ? `${record?.placeIds?.length || 0} posto(s)`
                  : 'Rede inteira'
              }
            />
            <SelectField
              source="summaryFrequency"
              label="Resumo"
              choices={SummaryFrequency.frequencyChoices}
            />
            <FunctionField
              label="Situação"
              render={(record: any) => (
                <Chip
                  size="small"
                  label={WhatsappIdentityStatus.translateStatus(record?.status)}
                  color={
                    record?.status === WhatsappIdentityStatus.active ? 'success' : 'default'
                  }
                />
              )}
            />
            <EditButton />
            <DeleteButton
              mutationMode="pessimistic"
              confirmTitle="Tirar o acesso deste número?"
              confirmContent="Ele para de receber e de responder na hora. O cadastro fica no histórico."
            />
          </Datagrid>
        </>
      </List>
    </RequiredChain>
  </Permission>
);

export default ListWhatsappNumber;
